import React, { useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import styles from './styles/styles.module.scss';
import FeedItemWrapper from '../FeedItemWrapper';
import TruncatedText from '../../TruncatedText';
import CommunityTrackCard from '../../cards/CommunityTrackCard';
import CommunityTrailCard from '../../cards/CommunityTrailCard';
import MiniTrailCard from '../../cards/MiniTrailCard';
import TranslateToggle from '../../TranslateToggle';

const ReviewFeedItem = ({ user, timestamp, description, activity, trail, review }) => {
  const { context } = useSelector(state => state, shallowEqual);
  const [commentIsTranslated, toggleCommentIsTranslated] = useState(false);

  const handleCardClick = () => {
    // WORK IN PROGRESS ADDING CARD CLICK
  };

  return (
    <FeedItemWrapper
      user={user}
      timestamp={timestamp}
      description={description}
      context={context}
      starRating={review && review.rating ? review.rating : null}
    >
      <div className={styles.container}>
        {review && (
          <div className={styles.review}>
            <TruncatedText text={review.comment} />
            {review.commentSource && (
              <TranslateToggle
                handleOnClick={() => toggleCommentIsTranslated(!commentIsTranslated)}
                isTranslated={commentIsTranslated}
                className={styles.translateBtn}
              />
            )}
          </div>
        )}
        <div className={styles.cardContainer}>
          {activity && <CommunityTrackCard context={context} handleCardClick={handleCardClick} idx={0} track={activity} />}
          {trail && !activity && (
            <CommunityTrailCard context={context} handleCardClick={handleCardClick} idx={0} key={`trail-${trail.ID}`} trail={trail} />
          )}
        </div>
        {trail && activity && <MiniTrailCard trail={trail} className={styles.spacerDiv} context={context} />}
      </div>
    </FeedItemWrapper>
  );
};

export default ReviewFeedItem;
